import { Injectable } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root',
})
export class UpdateCampaignNameServiceService {
    isNameUpdate: boolean = false;
    updateNameForm = this.formBuilder.group({
        name: ['', Validators.required],
    });
    isLoading: boolean = false;
    campaignName:any;
    campaignId: any;
    campaignStatus:any;
    constructor( private formBuilder: FormBuilder) {}

}
